// @flow
import styled from 'styled-components';
import Arrow from 'AssetsRoot/images/back-arrow.svg.react';

export const IconBackArrow = styled(Arrow)`
  cursor: pointer;
  vertical-align: text-top;
`;
